module.exports = "/_next/static/images/lock-e2c9b8457f53348ca399a313b125b3a5.svg";